export default __webpack_public_path__ + "images/U7.7cd19aa.png";